module.exports = __webpack_public_path__ + "static/media/2.6a3405a4.jpg";